import React from 'react';
import { Heart, Shield, Activity, TrendingUp, Scan, FileCheck } from 'lucide-react';
import { specializations } from '../data/mockData';
import '../styles/SpecializationsSection.css';

const SpecializationsSection = () => {
  const iconMap = {
    Heart: Heart,
    Shield: Shield,
    Activity: Activity,
    TrendingUp: TrendingUp,
    Scan: Scan,
    FileCheck: FileCheck
  };

  return (
    <section id="specializations" className="specializations-section">
      <div className="specializations-container">
        <div className="section-header">
          <div className="section-label">Clinical Expertise</div>
          <h2 className="section-title">Areas of Specialization</h2>
          <p className="section-description">
            Comprehensive cardiac care backed by advanced training and years of clinical experience
          </p>
        </div>
        
        <div className="specializations-grid">
          {specializations.map((spec, index) => {
            const Icon = iconMap[spec.icon];
            return (
              <div key={index} className="specialization-card">
                <div className="spec-icon-wrapper">
                  <Icon size={32} className="spec-icon" />
                </div>
                <h3 className="spec-title">{spec.title}</h3>
                <p className="spec-description">{spec.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SpecializationsSection;
